import SaveAltRounded from '@mui/icons-material/SaveAltRounded';

import Button from '../../Button';
import DropdownMenu from '../../DropdownMenu';

export interface DataTableExportProps {
  children: React.ReactNode;
  exporting?: boolean;
}

const DataTableExport = ({
  children,
  exporting = false,
}: DataTableExportProps) => {
  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild>
        <Button
          variant='outlined'
          size='condensed'
          color='secondary'
          loading={exporting}
          className='w-28'
          startIcon={<SaveAltRounded />}
        >
          Exportar
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align='start'>{children}</DropdownMenu.Content>
    </DropdownMenu>
  );
};

export default DataTableExport;
